var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('group-item',{attrs:{"is-name-displayed":false}},[_c('pp-select',{attrs:{"data-container":"transition-properties","items":_vm.targets,"placeholder":_vm.unSelectedValue},on:{"change":_vm.onTargetChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }